import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CodeMirror, { EditorView } from "@uiw/react-codemirror";
import { SecondaryButton } from "../UI";
import SuccessAlert from '../UI/Alert/SuccessAlert';
import EditIcon from '../../assets/icons/edit.svg';
import Loader from '../UI/Loader/Loader';
import backwardArrow from '../../assets/icons/backward-arrow.svg';
import { useUserContext } from '../../contexts/UserContext';
import { updatePermission } from '../../utils/APIs';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const PermissionDetails = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const { userData } = useUserContext()
    const { content } = useContentfulContext();

    const { state } = location;
    const data = state?.data;

    const [jsonCode, setJsonCode] = useState('');
    const [enableEdit, setEnableEdit] = useState(false);
    const [validationError, setValidationError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");

    useEffect(() => {
        if (data && data.configuration) {
            setJsonCode(JSON.stringify(data.configuration, null, 2));
        }
    }, [data]);

    const handleJsonChange = (newCode) => {
        setJsonCode(newCode);
        try {
            JSON.parse(newCode);
            setValidationError('');
        } catch (error) {
            setValidationError('Invalid JSON format');
        }
    };

    const updatePermissions = async (id, payload) => {
        try {
            setLoading(true);
            const res = await updatePermission(userData?.token, userData?.selectedOrganization?.org_token, id, payload);
            return res
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            const parsedData = JSON.parse(jsonCode);
            // some api call
            const res = await updatePermissions(data._id, parsedData)
            if(res.status){
                setSuccess(res.message)
                setTimeout(() => setSuccess(''), content.PERMISSION.timeout);
            }
            setValidationError('');
        } catch (error) {
            setValidationError('Invalid JSON format. Please correct it before saving.');
        }
    };

    return (
        <div class="my-4 px-8 w-full">

            <a href="#" class="font-medium text-primary hover:underline flex items-center" onClick={(e) => {
                e.preventDefault();
                navigate("/admin/permissions/")
            }}>
                <img src={backwardArrow} alt='' className='w-5 h-5 mr-2' /> {content.PERMISSION.back_cta_text}
            </a>

            <div className="w-full h-screen flex flex-col space-y-4 mt-2 mb-6 ">

                <div className="flex gap-4 items-baseline space-y-2 mb-6">
                    <h1 class="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">{content.PERMISSION.permission_config}</h1>
                    {!enableEdit && (
                        <img
                            src={EditIcon}
                            className="w-[20px] cursor-pointer"
                            onClick={() => setEnableEdit(true)}
                            alt="Edit"
                            title="Edit"
                        />
                    )}
                </div>

                {
                    loading && <Loader />
                }
                {success && (
                    <SuccessAlert disappearTime={content.PERMISSION.timeout}>
                        {success}
                    </SuccessAlert>
                )}

                <div className="flex-grow overflow-y-auto">
                    <CodeMirror
                        value={jsonCode}
                        height="100%"
                        readOnly={!enableEdit}
                        editable={enableEdit}
                        lineWrapping={true}
                        extensions={[EditorView.lineWrapping]}
                        onChange={handleJsonChange}
                    />
                </div>


                <div className="sticky bottom-0 bg-white p-6 border-t">
                    {validationError && (
                        <div className="text-base leading-tight tracking-tight text-red-500 mb-4">
                            {validationError}
                        </div>
                    )}
                    {enableEdit && (
                        <SecondaryButton handleClick={handleSave}>
                            Update configuration
                        </SecondaryButton>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PermissionDetails;
